import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'app-line-of-business-update',
  templateUrl: './line-of-business-update.component.html',
  styleUrls: ['./line-of-business-update.component.scss']
})
export class LineOfBusinessUpdateComponent implements OnInit {
  lineOfBusinessFormGroup: UntypedFormGroup;
  constructor(private fb: UntypedFormBuilder) { }

  ngOnInit() {
    this.lineOfBusinessFormGroup = this.fb.group({});
  }
  submitForm() {

  }

}
